import React from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import CustomStoryCard2 from "../../molecules/CustomStoryCard2";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import CustomStoryCard4 from "../../molecules/CustomStoryCard4";
import { getSlug } from "../../utils/utils";

import "./fourStoryHalfFeatured.m.css";

const FourStoryHalfFeatured = ({ collection, sections, domainSlug }) => {
  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const collectionSlug = getSlug(collection, sections, domainSlug);
  const stories = collection.items
    .filter(item => item.type === "story")
    .slice(0, 4)
    .map(item => item.story);

  if (!stories.length) {
    return null;
  }

  return (
    <div styleName="base" className="four-story-half-featured" data-testid="four-half-feature-story">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionName={collection.name}
          collectionSlug={collectionSlug}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}
      <div styleName="featured-storycard">
        <CustomStoryCard2
          story={stories[0]}
          className="first-story"
          headlineType={33}
          widths={global.deviceWidth > 875 ? [600] : [300]}
          isImageCaptionRequired={false}
          isSection={false}
          isMetaDataShown={false}
          aspectRatio={[16, 9]}
          imageType="image16x9"
          isSubheadline={!(global.deviceWidth > 875)}
          updatedFont={true}
          src="four-story-half-featured"
        />
        {stories.length > 1 &&
          stories
            .slice(1, 4)
            .map((story, index) => (
              <CustomStoryCard4
                key={index}
                story={story}
                className="remaining-stories"
                headlineType={34}
                widths={global.deviceWidth > 875 ? [600] : [120]}
                updatedFont={true}
              />
            ))}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    domainSlug: get(state, ["qt", "config", "domainSlug"], "")
  };
};

FourStoryHalfFeatured.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string
};

export default connect(mapStateToProps)(FourStoryHalfFeatured);
